import config from "@/config";
import http from "@/utils/request";

export default {
	search: {
		list: {
			url: `${config.API_URL}/admin/goods/goodSearchlist`,
			name: "搜索词列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/goods/storeGoodSearch`,
			name: "新增/编辑搜索词",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/goods/delGoodSearch`,
			name: "删除搜索词",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	service: {
		list: {
			url: `${config.API_URL}/admin/goods_service/index`,
			name: "服务保障列表",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/goods_service/store`,
			name: "新增/编辑服务保障",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/goods_service/show`,
			name: "服务保障详情",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/goods_service/del`,
			name: "删除服务保障",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		enable: {
			url: `${config.API_URL}/admin/goods_service/enable`,
			name: "启用/禁用",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		}
	},
	lesson: {
		list: {
			url: `${config.API_URL}/admin/lesson/list`,
			name: "课程商品列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		listSimple: {
			url: `${config.API_URL}/admin/lesson/listSimple`,
			name: "课程商品列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/lesson/store`,
			name: "新增/编辑课程商品",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		
		delete: {
			url: `${config.API_URL}/admin/lesson/del`,
			name: "删除课程商品",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		
	},

};
